var _style, _rect, _rect2, _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _defs2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{fill:#304959;}\n\t.st2{clip-path:url(#SVGID_00000148659952844163103580000005690578556299409043_);}\n\t.st3{fill:#253B4C;}\n\t.st4{fill:#182935;}\n\t.st5{fill:#F78D15;}\n\t.st6{fill:#FFFFFF;}\n\t.st7{fill:#A8B3BE;}\n\t.st8{fill:#C3CDD9;}\n\t.st9{fill:#E95D2F;}\n\t.st10{fill:#D1401A;}\n\t.st11{fill:#F27C20;}\n\t.st12{opacity:0.5;}\n\t.st13{clip-path:url(#SVGID_00000087404782789156849760000013970693723713897140_);}\n\t.st14{fill:#DBE8DE;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 24,
    height: 24
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4915"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_2147",
    x: 11.4,
    y: 3.8,
    className: "st1",
    width: 1.2,
    height: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4914"
  }, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 3.9,
    y: 3.2,
    width: 16.1,
    height: 17.6
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000122682622055241388340000015140250326499113141_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000122682622055241388340000015140250326499113141_)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4913"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9176",
    className: "st3",
    d: "M12.9,4.1h-1.8c-0.2,0-0.4-0.2-0.4-0.4V3.6c0-0.2,0.2-0.4,0.4-0.4h1.8 c0.2,0,0.4,0.2,0.4,0.4v0.1C13.3,4,13.1,4.1,12.9,4.1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9177",
    className: "st4",
    d: "M13.2,3.3c0,0,0,0.1,0,0.1v0.1C13.2,3.8,13,4,12.8,4H11c-0.1,0-0.2,0-0.3-0.1 c0.1,0.2,0.2,0.2,0.4,0.2h1.8c0.2,0,0.4-0.2,0.4-0.4l0,0V3.6C13.3,3.5,13.2,3.4,13.2,3.3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9254",
    className: "st1",
    d: "M15.7,6.2l0.5-0.8l0.7,0.4l-0.5,0.8L15.7,6.2z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9178",
    className: "st3",
    d: "M16.9,6.1l-1-0.6c-0.1-0.1-0.2-0.2-0.1-0.4l0,0l0,0C15.9,5,16.1,4.9,16.2,5l1,0.6 c0.1,0.1,0.2,0.2,0.1,0.4l0,0l0,0C17.2,6.2,17,6.2,16.9,6.1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9179",
    className: "st3",
    d: "M16.9,6.1l-1-0.6c-0.1-0.1-0.2-0.2-0.1-0.4l0,0l0,0C15.9,5,16.1,4.9,16.2,5l1,0.6 c0.1,0.1,0.2,0.2,0.1,0.4l0,0l0,0C17.2,6.2,17,6.2,16.9,6.1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9180",
    className: "st4",
    d: "M17.3,5.7c0,0.1,0,0.1,0,0.1l0,0C17.2,6,17,6.1,16.8,6l-1-0.6c0,0-0.1-0.1-0.1-0.1 c0,0.1,0.1,0.2,0.1,0.2l1,0.6c0.1,0.1,0.3,0,0.4-0.1l0,0C17.3,5.9,17.4,5.8,17.3,5.7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9181",
    className: "st5",
    d: "M20.1,12.9c0,4.4-3.7,7.9-8.1,7.9c-4.4,0.1-8-3.4-8-7.8c-0.1-4.4,3.4-8,7.8-8 c0.1,0,0.2,0,0.2,0C16.4,4.9,20,8.4,20.1,12.9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9182",
    className: "st6",
    d: "M18.3,12.9c0.1,3.5-2.7,6.4-6.2,6.5c-3.5,0.1-6.4-2.7-6.5-6.2s2.7-6.4,6.2-6.5 c0,0,0.1,0,0.1,0C15.5,6.6,18.3,9.4,18.3,12.9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9183",
    className: "st7",
    d: "M12,8.4C12,8.4,11.9,8.4,12,8.4L12,8.4l-0.1-1c0,0,0-0.1,0.1-0.1 c0.1,0,0.1,0,0.1,0.1L12,8.4C12.1,8.3,12,8.4,12,8.4L12,8.4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9184",
    className: "st7",
    d: "M12,18.4C12,18.4,11.9,18.4,12,18.4L12,18.4l-0.1-1c0,0,0-0.1,0.1-0.1 c0.1,0,0.1,0,0.1,0.1L12,18.4C12.1,18.4,12,18.4,12,18.4L12,18.4"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9185",
    className: "st7",
    d: "M7.4,12.9h-1c0,0-0.1,0-0.1-0.1s0-0.1,0.1-0.1h1C7.4,12.8,7.4,12.8,7.4,12.9 C7.4,12.9,7.4,12.9,7.4,12.9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9186",
    className: "st8",
    d: "M8.5,9.6C8.5,9.6,8.5,9.6,8.5,9.6L8,9c0,0,0-0.1,0-0.1l0,0c0,0,0.1,0,0.1,0l0.5,0.5 C8.6,9.4,8.6,9.5,8.5,9.6L8.5,9.6C8.6,9.5,8.5,9.5,8.5,9.6"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9187",
    className: "st8",
    d: "M15.5,9.6C15.5,9.6,15.4,9.6,15.5,9.6c-0.1-0.1-0.1-0.1-0.1-0.1l0,0l0.5-0.5 c0,0,0.1,0,0.1,0C16,9,16,9,16,9l0,0L15.5,9.6C15.5,9.5,15.5,9.5,15.5,9.6"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9188",
    className: "st8",
    d: "M16,16.8C16,16.8,15.9,16.8,16,16.8l-0.6-0.5c0,0,0-0.1,0-0.1l0,0c0,0,0.1,0,0.1,0 l0.5,0.5C16,16.7,16,16.8,16,16.8L16,16.8C16,16.8,16,16.8,16,16.8"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9189",
    className: "st8",
    d: "M8,16.8C8,16.8,8,16.8,8,16.8c-0.1-0.1-0.1-0.1-0.1-0.1l0,0l0.5-0.5c0,0,0.1,0,0.1,0 c0,0,0,0.1,0,0.1l0,0L8,16.8C8.1,16.8,8.1,16.8,8,16.8"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9190",
    className: "st8",
    d: "M6.8,15C6.8,15,6.7,15,6.8,15c-0.1-0.1-0.1-0.1,0-0.2l0,0l0.7-0.3c0,0,0.1,0,0.1,0 s0,0.1-0.1,0.1l0,0L6.8,15C6.8,15,6.8,15,6.8,15"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9191",
    className: "st8",
    d: "M9.8,18C9.8,18,9.8,18,9.8,18c-0.1,0-0.1-0.1-0.1-0.1l0,0l0.3-0.6c0,0,0.1-0.1,0.1,0 c0,0,0.1,0.1,0.1,0.1l0,0L9.8,18C9.9,18,9.9,18,9.8,18"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9192",
    className: "st8",
    d: "M14.1,18C14.1,18,14,18,14.1,18l-0.3-0.7c0,0,0-0.1,0.1-0.1l0,0c0,0,0.1,0,0.1,0 l0.3,0.6C14.2,17.9,14.2,18,14.1,18L14.1,18C14.1,18,14.1,18,14.1,18"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9193",
    className: "st8",
    d: "M17.2,15.1C17.2,15.1,17.1,15.1,17.2,15.1l-0.7-0.3c0,0-0.1-0.1,0-0.1l0,0 c0,0,0.1-0.1,0.1,0l0.6,0.3C17.2,14.9,17.2,15,17.2,15.1L17.2,15.1C17.2,15.1,17.2,15.1,17.2,15.1"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9194",
    className: "st8",
    d: "M16.5,11.1C16.5,11.1,16.5,11.1,16.5,11.1c-0.1-0.1-0.1-0.1,0-0.2l0,0l0.7-0.3 c0,0,0.1,0,0.1,0s0,0.1,0,0.1l0,0L16.5,11.1C16.6,11.1,16.5,11.1,16.5,11.1"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9195",
    className: "st8",
    d: "M13.9,8.5C13.9,8.5,13.9,8.5,13.9,8.5c-0.1,0-0.1-0.1-0.1-0.1l0,0l0.3-0.6 c0,0,0.1-0.1,0.1,0s0.1,0.1,0.1,0.1l0,0L13.9,8.5C14,8.5,13.9,8.5,13.9,8.5"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9196",
    className: "st8",
    d: "M10.1,8.5C10.1,8.5,10.1,8.5,10.1,8.5L9.8,7.8c0,0,0-0.1,0.1-0.1l0,0 c0,0,0.1,0,0.1,0.1l0.3,0.6C10.2,8.4,10.2,8.5,10.1,8.5L10.1,8.5C10.2,8.5,10.2,8.5,10.1,8.5"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9197",
    className: "st8",
    d: "M7.5,11.1C7.5,11.1,7.5,11.1,7.5,11.1l-0.7-0.3c0,0-0.1-0.1-0.1-0.1l0,0 c0,0,0.1-0.1,0.1,0l0.6,0.3C7.5,10.9,7.6,11,7.5,11.1L7.5,11.1C7.5,11.1,7.5,11.1,7.5,11.1"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9198",
    className: "st7",
    d: "M17.6,12.9h-1c0,0-0.1,0-0.1-0.1s0-0.1,0.1-0.1h1C17.6,12.8,17.7,12.8,17.6,12.9 C17.7,12.9,17.6,12.9,17.6,12.9"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9199",
    className: "st1",
    d: "M12,13.2c-0.1,0-0.1,0-0.2,0l-2.7-1.6C9,11.4,9,11.2,9.1,11.1l0,0 c0.1-0.1,0.3-0.2,0.4-0.1l2.7,1.6c0.1,0.1,0.2,0.3,0.1,0.4l0,0C12.2,13.1,12.1,13.2,12,13.2"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9200",
    className: "st9",
    d: "M13.1,12.9c0,0.6-0.5,1.1-1.1,1.1s-1.1-0.5-1.1-1.1s0.5-1.1,1.1-1.1h0 C12.6,11.8,13.1,12.2,13.1,12.9"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9201",
    className: "st10",
    d: "M12.5,12.9c0,0.3-0.2,0.5-0.5,0.6s-0.5-0.2-0.6-0.5c0-0.3,0.2-0.5,0.5-0.6l0,0 C12.3,12.3,12.5,12.6,12.5,12.9L12.5,12.9"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9202",
    className: "st11",
    d: "M14,5.2C14.9,6,15.6,6.9,16,8c1.5,1.2,2.4,3,2.4,4.9c0,3.5-2.9,6.3-6.3,6.2l0,0 c-1.9,0-3.7-0.9-4.9-2.3c-1.1-0.4-2.1-1-2.9-1.9c0.9,3.5,4.2,6,7.8,5.9c4.4,0.1,8-3.4,8-7.8C20.1,9.3,17.6,6.1,14,5.2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4912",
    className: "st12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4911"
  }, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000109016723718182130250000007940451248689737405_",
    x: 7,
    y: 8,
    width: 11.3,
    height: 11.1
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000084514354087433514340000007250585866568163510_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000109016723718182130250000007940451248689737405_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000084514354087433514340000007250585866568163510_)"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4910"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9203",
    className: "st14",
    d: "M12,19.1c3.5,0,6.3-2.8,6.3-6.2l0,0c0-1.9-0.9-3.7-2.4-4.9 c0.3,0.7,0.4,1.5,0.4,2.3c0,3.8-3.2,6.9-7,6.8c-0.8,0-1.6-0.1-2.4-0.4C8.3,18.2,10.1,19.1,12,19.1"
  }))))))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.429ef5d3f4e909acfda53ff9e4d97638.svg";
export { ForwardRef as ReactComponent };